const inputTextLimit = 250;
const nameInputLimit = 20;
const emailInputLimit = 70;
const inputDescLimit = 10000;

export { inputTextLimit, inputDescLimit, nameInputLimit, emailInputLimit }